module.exports = __webpack_public_path__ + "static/media/logo@2x.73d6fb63.png";